// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilderTile16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder-tile': IconDashboardBuilderTile;
    }
}

/**
 * The icon component for the 'dashboardBuilderTile' icon
 */
export class IconDashboardBuilderTile extends IconSvg {
    public constructor() {
        super(dashboardBuilderTile16X16);
    }
}

registerIconSvg('icon-dashboard-builder-tile', IconDashboardBuilderTile);
export const iconDashboardBuilderTileTag = 'nimble-icon-dashboard-builder-tile';
